import { FC, memo, ReactNode, useEffect } from 'react'
import { ReactComponent as CloseIcon } from 'public/assets/pricing/icons/close.svg'

/* styles */
import styles from './_.module.css'

interface IProps {
  children: ReactNode
  isOpen: boolean
  showModalHeader?: boolean
  toggle: () => void
}

const Modal: FC<IProps> = ({
  isOpen = false,
  toggle,
  children,
  showModalHeader = true
}) => {
  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden'
    else document.body.style.overflow = 'visible'
  }, [isOpen])

  return isOpen ? (
    <div className={styles.modalContainer}>
      <div className="modal">
        {showModalHeader && (
          <div className="flex items-center flex-row-reverse justify-start py-1">
            <CloseIcon
              name="close"
              onClick={toggle}
              className="cursor-pointer text-white"
            />
          </div>
        )}
        <div className="modal-body">{children}</div>
      </div>
    </div>
  ) : null
}

export default memo(Modal)
